module.exports = __webpack_public_path__ + "img/image.cf31ebc1.svg";